/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { apiAppUpload } from 'api/request';
import urlApp from 'api/urlApp';
import { size } from 'lodash';
import HttpRequestError from 'utils/HttpRequetsError';

export async function postUploadAPI(payload: any): Promise<any> {
  const {data} = await apiAppUpload.post(urlApp.uploadFilePath, payload);
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}